import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import { enablePush, disablePush, getPushStatus } from "@/lib/push";

type Status = "loading" | "unsupported" | "denied" | "subscribed" | "default";

export function NotificationToggle() {
  const [status, setStatus] = useState<Status>("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushStatus().then(setStatus).catch(() => setStatus("unsupported"));
  }, []);

  if (status === "loading" || status === "unsupported") return null;

  const handle = async () => {
    setBusy(true);
    try {
      if (status === "subscribed") {
        await disablePush();
        setStatus("default");
        toast.success("Οι ειδοποιήσεις απενεργοποιήθηκαν.");
      } else {
        await enablePush();
        setStatus("subscribed");
        toast.success("Ειδοποιήσεις ενεργές! Θα σε ενημερώνουμε 🐼");
      }
    } catch (e) {
      const msg = (e as Error).message || "Κάτι πήγε στραβά.";
      setStatus(Notification.permission === "denied" ? "denied" : status);
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  if (status === "denied") {
    return (
      <p className="mt-3 inline-flex items-center gap-2 text-xs text-muted-foreground">
        <BellOff className="h-4 w-4" />
        Οι ειδοποιήσεις είναι αποκλεισμένες στον browser σου.
      </p>
    );
  }

  const subscribed = status === "subscribed";
  return (
    <button
      type="button"
      onClick={handle}
      disabled={busy}
      className="mp-bouncy mt-4 inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-sm font-medium text-foreground shadow-sm hover:bg-accent disabled:opacity-60"
    >
      {subscribed ? <BellRing className="h-4 w-4 text-primary" /> : <Bell className="h-4 w-4 text-primary" />}
      {busy ? "Παρακαλώ περίμενε…" : subscribed ? "Ειδοποιήσεις: ΕΝΕΡΓΕΣ" : "🔔 Ενεργοποίηση ειδοποιήσεων"}
    </button>
  );
}
